/* ===== pageNav.ts — الانتقال بين صفحات التطبيق ذي الصفحة الواحدة =====
   في الأصل كان الانتقال بين الصفحات تحميلاً لملف HTML آخر (location.href=…).
   الآن ملف واحد وموجِّه واحد (pageRouter.ts) يختار الصفحة من المسار؛ هذه الوحدة
   الصغيرة هي الباب إليه لمن يحتاج الانتقال (صفحة الدخول بعد نجاحه) دون أن يستورد
   الموجِّه نفسه وحِزم صفحاته.

   openPage(url): يُسلَّم إلى الموجِّه إن كان يعمل — فيقرّر هو: تبديل داخل المستند
   (pushState + تركيب الصفحة الجديدة) أو تنقّل كامل (انظر قاعدته في pageRouter.ts).
   بلا موجِّه (اختبار يركّب شاشة وحدها) ⇒ تنقّل كامل كالأصل. */

type Navigator = (url: string) => void;

let navigator: Navigator | null = null;

/** يسجّله الموجِّه عند بدئه (ويُلغيه بـ null). */
export function setPageNavigator(n: Navigator | null): void {
  navigator = n;
}

export function openPage(url: string): void {
  if (navigator) navigator(url);
  else window.location.href = url;
}
